import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-lien-utile',
  templateUrl: './lien-utile.component.html',
  styleUrls: ['./lien-utile.component.scss']
})
export class LienUtileComponent implements OnInit {
  titre:any ="Coronavirus";
  date_video:any ="7 février 2020";
  source_video : any ="coronavirus_OMS";
  constructor() { }

  ngOnInit() {
  }

}
